import { Skeleton, Stack } from "@mui/material";
import { PillSkeleton, TextSkeleton } from "@src/appV2/redesign/system/ui-components";

export function ActivityItemSkeleton() {
  return (
    <Stack direction="column" spacing={2}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={5}>
        <Stack direction="row" spacing={2} alignItems="center">
          <Skeleton
            variant="rounded"
            sx={(theme) => ({ height: theme.size?.icon.small, width: theme.size?.icon.small })}
          />
          <TextSkeleton variant="body1" width="8ch" />
        </Stack>

        <Stack direction="row" spacing={2} alignItems="center">
          <PillSkeleton width="3rem" size="small" />
        </Stack>
      </Stack>
    </Stack>
  );
}
